import { useEffect } from "react";
import "./index.css";
// import "jotai-devtools/styles.css";
// import { DevTools, useAtomsDebugValue } from "jotai-devtools";
import { ErrorToast, LoadingOverlay, NetworkStatus, PWAInstallBanner, ToastContainer } from "./components";
import { registerSW } from "./hooks/usePWA";
import Routes from "./Routes";
import { StoreProvider } from "./store/Provider";

function DebugAtoms() {
  // useAtomsDebugValue({ enabled: true });
  return null;
}

export function App() {
  useEffect(() => {
    // Register service worker
    registerSW();
  }, []);

  return (
    <StoreProvider>
      {/* <DevTools /> */}
      <NetworkStatus />
      <Routes />
      <PWAInstallBanner />
      <LoadingOverlay />
      <ErrorToast />
      <DebugAtoms />
      <ToastContainer />
    </StoreProvider>
  );
}

export default App;
